import { AnimationTriggerMetadata } from '@angular/animations';
import { animate, state, style, transition, trigger } from '@angular/animations';

export const fadeOutAnimation: AnimationTriggerMetadata =
  trigger(
    'fadeOutAnimation', [
      state('true', 
        style({ opacity: .13, color: '#000' })),
      transition('* => true', [
        animate('500ms ease-out')
      ])
    ]
  );
